import React, { useEffect, useState } from 'react';
import { CampaignAPI, NetworksAPI } from '../services/api';
import { Campaign, Network } from '../types';
import { CampaignContext } from './CampaignContextDefinition';
import { useError } from './ErrorContext';

export const CampaignProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(null);
    const [selectedNetwork, setSelectedNetwork] = useState<Network | null>(null);
    const [loadingCampaigns, setLoadingCampaigns] = useState<boolean>(false);
    const { setError } = useError();


    const loadCampaigns = async () => {
        setLoadingCampaigns(true);
        try {
            const responseNetworks = await NetworksAPI.getNetworks();
            const networks: Network[] = responseNetworks.data;
            const responseCampaigns = await CampaignAPI.getAllCampaigns();
            const campaigns: Campaign[] = responseCampaigns.data;

            const campaignsAvailable: Campaign[] = [];
            campaigns.forEach(c => {
                networks.forEach(n => {
                    if (c.network_slug == n.slug) campaignsAvailable.push(c);
                })
            });
            setCampaigns(campaignsAvailable);
            setSelectedCampaign(current => current ? campaignsAvailable.find(item => item.id === current.id) ?? current : null);
        } catch (error) {
            console.error('Error loading campaigns:', error);
            setCampaigns([]);
            setError('Failed to load campaigns.' + error)
        } finally {
            setLoadingCampaigns(false);
        }
    };


    const refreshCampaigns = async () => {
        await loadCampaigns();
    };

    // Load campaigns when network changes
    useEffect(() => {
        if (selectedCampaign) {
            const networkSlug = selectedCampaign.network_slug;
            NetworksAPI.getNetworkDetail(networkSlug)
                .then((values) => {
                    setSelectedNetwork(values.data)
                })
        } else {
            // Reset campaigns when no network is selected
            setCampaigns([]);
            setSelectedCampaign(null);
        }
    }, [selectedCampaign]);

    return (
        <CampaignContext.Provider
            value={{
                campaigns,
                selectedCampaign,
                setSelectedCampaign,
                loadingCampaigns,
                selectedNetwork,
                setSelectedNetwork,
                refreshCampaigns,
                loadCampaigns
            }}
        >
            {children}
        </CampaignContext.Provider>
    );
};

